import script from "./InformationNfts.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationNfts.vue?vue&type=script&lang=ts&setup=true"

import "./InformationNfts.vue?vue&type=style&index=0&id=04758091&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04758091"]])

export default __exports__